export default __webpack_public_path__ + "static/media/yair-shriki.cf83fb82.png";